import {tabSlice} from './tabSlice';
import {cartSlice} from './cartSlice';
import {filterSlice} from './filterSlice';
import {wishlistSlice} from './wishlistSlice';

export const slices = {
  tabSlice,
  cartSlice,
  filterSlice,
  wishlistSlice,
};
